<template>
  <div class="ful-page">
    <div class="ful-page-wrapper">
      <PageHeader title="配送信息" @back="goBack" />
      <div class="ful-card">
        <div class="ful-body">
          <div class="space-y-7">
            <!-- 收件人信息 -->
            <section class="ful-section">
              <div class="ful-section-heading">
                <span class="ful-section-number">01</span>
                <svg class="ful-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <h2 class="ful-section-title">收件人信息</h2>
                <a style="color: #d35342; font-size: 18px; margin-left: auto; cursor: pointer;"
                  @click="toAddressList">使用地址簿 (请先添加收件人信息)</a>
              </div>
              <el-form label-width="200px" label-position="right" class="ful-form-row" v-model="deliveryFormData"
                v-show="addressInfoVisible">
                <el-form-item label="*姓名：" class="form-item">
                  <el-input v-model="deliveryFormData.receiverName" ref="nameId" type="text" placeholder="请输入收件人姓名"
                    clearable></el-input>
                </el-form-item>
                <el-form-item label="*联系电话：" class="form-item">
                  <el-input @wheel.native.prevent v-model="deliveryFormData.phoneNo" ref="phoneId" type="number"
                    placeholder="请输入联系人手机号码" clearable></el-input>
                </el-form-item>
                <el-form-item label="*省市区：" class="form-item">
                  <el-cascader class="address-picker" ref="adressCas" placeholder="请选择省市区" @change="addressChange"
                    :value="addressInfo" :props="props"></el-cascader>
                  <span v-show="addressTemp && addressTemp.length > 0"
                    style="position: absolute; color: #606266; background-color: white; left: 10px; line-height: 20px; width: 300px; text-align: start; font-size: 18px; z-index: 1;">{{
                      addressTemp }}</span>
                </el-form-item>
                <el-form-item label="*详细地址：" class="form-item">
                  <el-input v-model="deliveryFormData.street" ref="customAddressId" type="text"
                    placeholder="请输入详细地址(街道门牌信息)" clearable></el-input>
                </el-form-item>
                <el-form-item label="邮政编码：" class="form-item">
                  <el-input @wheel.native.prevent v-model="deliveryFormData.zipCode" type="number" placeholder="请输入邮政编码"
                    clearable></el-input>
                </el-form-item>
              </el-form>
            </section>

            <!-- 煎药信息（动态表单） -->
            <section class="ful-section">
              <div class="ful-section-heading">
                <span class="ful-section-number">02</span>
                <svg class="ful-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <path d="M16 10a4 4 0 0 1-8 0"></path>
                </svg>
                <h2 class="ful-section-title">配送服务</h2>
              </div>
              <el-form label-width="200px" label-position="right" class="ful-form-row" :model="drugFormData"
                @submit.native.prevent>
                <!-- 中草药形态 / 超微饮片：产品形态 -->
                <el-form-item class="form-item radio-group-warp" :label="isSuperfine ? '*产品形态：' : '*中草药形态：'">
                  <div class="ful-radio-group">
                    <el-radio-group v-model="drugFormData.currentFormName" v-for="value in forms" :key="value.formCode"
                      @change="radioChange">
                      <el-radio-button class="radio-button" :label="value.formName" border>{{ value.formName
                      }}</el-radio-button>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <div class="ful-hint">{{ isSuperfine ? '请先选择产品形态' : '请先选择中草药形态' }}</div>
                <!-- 配送中心 -->
                <el-form-item class="form-item" label="*请选择配送中心：">
                  <div class="ful-form-control">
                    <el-select v-model="deliveryFormData.deliveryId" clearable placeholder="请选择"
                      @change="getConfigAndDeliveryId" style="flex: 1; min-width: 200px;">
                      <el-option v-for="item in options" :key="item.deliveryId" :label="item.deliveryName"
                        :value="item.deliveryId"></el-option>
                    </el-select>
                    <button class="ful-btn-ghost" @click.prevent="switchList(isswitchList)">{{ isswitchList }}</button>
                  </div>
                </el-form-item>
                <div class="ful-hint" v-if="PromptOnAllocationQuantity">{{ PromptOnAllocationQuantity }}</div>
                <!-- 几副药 / 超微饮片：几剂 -->
                <el-form-item :label="isSuperfine ? '*几剂：' : '*几副药：'" class="form-item">
                  <el-input @wheel.native.prevent v-model="drugFormData.drugCount" ref="drugCountId" type="number"
                    @input="handleInput" autocomplete="off"
                    :placeholder="isSuperfine ? '请输入几剂，只能是大于0的数字' : '请输入几副药，只能是大于0的数字'"
                    @keyup.native.enter></el-input>
                </el-form-item>
                <!-- 动态字段：装袋数量 -->
                <el-form-item v-if="adjustmentQuantityType && medicineFormSpecificationsQuantity.length > 0"
                  :label="`*${adjustmentQuantityType}：`">
                  <div class="ful-radio-group">
                    <el-radio-group v-model="drugFormData.quantityDispensed" @change="PriceInfoDel">
                      <el-radio-button v-for="n in medicineFormSpecificationsQuantity" :label="n.specifications"
                        :key="n.specificationsId"></el-radio-button>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <!-- 动态字段：规格 -->
                <el-form-item v-if="specificationType" :label="`*${specificationType}：`">
                  <div class="ful-radio-group">
                    <el-radio-group v-model="drugFormData.specifications" @change="PriceInfoDel">
                      <el-radio-button v-for="n in allocationQuantity" :label="n.specifications"
                        :key="n.specificationsId"></el-radio-button>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <!-- 动态字段：频次 -->
                <el-form-item v-if="frequencyString" :label="`*${frequencyString}：`" class="form-item">
                  <div class="ful-radio-group" v-if="medicineFormSpecificationsFrequency.length > 0">
                    <el-radio-group v-model="drugFormData.frequency" @change="PriceInfoDel">
                      <el-radio-button v-for="n in medicineFormSpecificationsFrequency" :label="n.specifications"
                        :key="n.specificationsId"></el-radio-button>
                    </el-radio-group>
                  </div>
                  <el-input v-else v-model="drugFormData.frequency" :placeholder="`请输入${frequencyString}`"
                    @input="PriceInfoDel"></el-input>
                </el-form-item>
                <!-- 动态字段：剂量 -->
                <el-form-item v-if="dosageString" :label="`*${dosageString}：`" class="form-item">
                  <div class="ful-radio-group" v-if="medicineFormSpecificationsDosage.length > 0">
                    <el-radio-group v-model="drugFormData.dosage" @change="PriceInfoDel">
                      <el-radio-button v-for="n in medicineFormSpecificationsDosage" :label="n.specifications"
                        :key="n.specificationsId"></el-radio-button>
                    </el-radio-group>
                  </div>
                  <el-input v-else v-model="drugFormData.dosage" :placeholder="`请输入${dosageString}`"
                    @input="PriceInfoDel"></el-input>
                </el-form-item>
                <!-- 总价格 -->
                <el-form-item class="form-item" label="总价格：">
                  <div class="ful-form-control">
                    <button class="ful-btn-primary" @click.prevent="medicinePrice">获取价格</button>
                    <span v-if="PriceInfo" style="color: #d35845; font-size: 16px; font-weight: 700;">
                      {{ isSuperfine ? '支付价格' : '患者支付价格' }}：{{ PriceInfo.referPrice || "0" }}元，其中药价{{ PriceInfo.medicineReferPrice || "0" }}元，加工费{{
                        PriceInfo.processingFee || "0" }}元，快递费{{ PriceInfo.expressFee || "0" }}元
                    </span>
                  </div>
                </el-form-item>
                <!-- 处方笺寄送 -->
                <el-form-item v-if="!isSuperfine" label="处方笺寄送：" class="form-item">
                  <div class="ful-radio-toggle">
                    <el-radio-group v-model="drugFormData.prescriptionWithShipment">
                      <el-radio-button label="是" border>是</el-radio-button>
                      <el-radio-button label="否" border>否</el-radio-button>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <!-- 备注 -->
                <el-form-item label="备注：" class="form-item" style="margin-top: 20px">
                  <el-input v-model="drugFormData.remark" type="textarea" placeholder="如有特殊需求请注明" autosize
                    maxlength="100" show-word-limit></el-input>
                </el-form-item>
              </el-form>
            </section>
          </div>

          <!-- 配送摘要 -->
          <aside class="ful-sidebar">
            <div class="ful-sidebar-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 11l3 3L22 4"></path>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
              配送摘要
            </div>
            <dl v-if="consultInfo">
              <div style="display: flex; justify-content: space-between; gap: 16px;">
                <dt>{{ isSuperfine ? '姓名' : '病人姓名' }}</dt>
                <dd>{{ consultInfo.name }}</dd>
              </div>
              <div style="display: flex; justify-content: space-between; gap: 16px;">
                <dt>{{ isSuperfine ? '调理方案' : '处方名称' }}</dt>
                <dd>{{ pane.title || '-' }}</dd>
              </div>
              <div style="display: flex; justify-content: space-between; gap: 16px;">
                <dt>{{ isSuperfine ? '每剂数量' : '药材总量' }}</dt>
                <dd>
                  <template v-if="isSuperfine">{{ pane.totalWeight || '0' }} 包</template>
                  <template v-else>{{ pane.count || '0' }} 味 · {{ pane.totalWeight || '0' }} 克</template>
                </dd>
              </div>
              <div style="display: flex; justify-content: space-between; gap: 16px;">
                <dt>{{ isSuperfine ? '参考价格' : '药价参考' }}</dt>
                <dd style="color: #d35845; font-weight: 700;">{{ pane.charge || '0' }} 元</dd>
              </div>
              <div class="divider" v-if="!isSuperfine">
                <dt>有效使用期</dt>
                <dd style="color: #d35845; font-weight: 700;">{{ pane.startDate || '-' }} ~ {{ pane.endDate || '-' }}
                </dd>
              </div>
            </dl>
            <dl v-else>
              <div style="color: #94a3b8; font-size: 14px;">加载中...</div>
            </dl>
          </aside>
        </div>

        <!-- 底部信息 -->
        <div class="ful-bottom">
          <section style="max-width: 1050px; margin: 0 auto;">
            <div class="ful-collapse-header" @click="activeNames = activeNames == '1' ? '' : '1'">
              <span>基本信息</span>
              <svg class="ful-collapse-icon" :class="{ 'is-open': activeNames == '1' }" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
            <div v-show="activeNames == '1'" class="ful-collapse-content">
              <span v-if="consultInfo">姓名：{{ consultInfo.name }}</span>
              <span v-if="consultInfo">性别：{{ consultInfo.sex == '1' ? '男' : '女' }}</span>
              <span v-if="consultInfo">电话：{{ consultInfo.phoneNo }}</span>
              <span v-if="consultInfo">出生日期：{{ consultInfo.birthday }}<span
                  v-if="shouldShowTime(consultInfo.birthHour, consultInfo.birthMinute)"> {{
                    formatTimeValue(consultInfo.birthHour) }}:{{ formatTimeValue(consultInfo.birthMinute) }}</span></span>
              <span v-if="consultInfo">常住地址：{{ consultInfo.liveArea }}</span>
              <span v-if="consultInfo">出生地址：{{ consultInfo.birthArea }}</span>
              <span v-if="consultInfo && consultInfo.useDate">{{ isSuperfine ? '开始调理时间：' : '开始服药时间：' }}{{ consultInfo.useDate }}</span>
              <span v-if="consultInfo && (consultInfo.useDays || consultInfo.ganZhiPrescriptionHourRange)">
                {{ isSuperfine
                  ? (consultInfo.ganZhiPrescriptionHourRange ? '服用时段' : '调理天数')
                  : (consultInfo.ganZhiPrescriptionHourRange ? '服药时间段' : '服药天数') }}：{{
                  consultInfo.ganZhiPrescriptionHourRange || consultInfo.useDays }}
              </span>
            </div>

            <div class="ful-collapse-header" @click="activeNames = activeNames == '3' ? '' : '3'">
              <span> {{ pane.title || (isSuperfine ? '调理方案' : '处方') }}</span>
              <svg class="ful-collapse-icon" :class="{ 'is-open': activeNames == '3' }" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>

            </div>
            <DrugTable v-show="activeNames == '3'" :tablePrescription="pane"
              :timeRange="consultInfo.ganZhiPrescriptionHourRange || ''" :supplyDays="pane.supplyDays"
              :showSupplyDays="true" :chaoweiMode="isSuperfine" />
          </section>

          <div class="ful-actions">
            <button class="ful-btn-submit" @click="submit">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
              统一配送
            </button>
            <!-- <button class="ful-btn-draft" @click="saveDraft">保存草稿</button> -->
          </div>
        </div>
      </div>
    </div>

    <ConfirmDialog :visible.sync="dialogVisible" @confirm="confirmOrder">
      <li><b>{{ isSuperfine ? '姓名' : '病人姓名' }}：</b>{{ consultInfo.name }}</li>
      <li><b>{{ isSuperfine ? '产品形态' : '中草药形态' }}：</b>{{ currentForm.formName }}</li>
      <li><b>{{ isSuperfine ? '几剂' : '几副药' }}：</b>{{ drugFormData.drugCount }}</li>
      <li v-if="drugFormData.quantityDispensed"><b>{{ adjustmentQuantityType }}：</b>{{ drugFormData.quantityDispensed }}
      </li>
      <li v-if="drugFormData.specifications"><b>{{ specificationType }}：</b>{{ drugFormData.specifications }}</li>
      <li v-if="drugFormData.frequency"><b>{{ frequencyString }}：</b>{{ drugFormData.frequency }}</li>
      <li v-if="drugFormData.dosage"><b>{{ dosageString }}：</b>{{ drugFormData.dosage }}</li>
      <li v-if="!isSuperfine && drugFormData.prescriptionWithShipment"><b>处方笺寄送：</b>{{ drugFormData.prescriptionWithShipment }}</li>
      <li><b>收件人姓名：</b>{{ deliveryFormData.receiverName }}</li>
      <li><b>收件人联系方式：</b>{{ deliveryFormData.phoneNo }}</li>
      <div class="dialog-address"><b>收件地址：</b>{{ deliveryFormData.province + deliveryFormData.city +
        deliveryFormData.county + deliveryFormData.street }}</div>
      <li><b>备注：</b>{{ drugFormData.remark != null && drugFormData.remark.length == 0 ? '无' : drugFormData.remark }}
      </li>
    </ConfirmDialog>
  </div>
</template>

<script>
import PageHeader from "@/components/widgets/PageHeader.vue";
import ConfirmDialog from "@/components/widgets/ConfirmDialog.vue";
import DrugTable from './common/DrugTable.vue';
import fulfillmentMixin from "../../js/fulfillmentMixin";

export default {
  name: "fulConfirm",
  components: { PageHeader, ConfirmDialog, DrugTable },
  mixins: [fulfillmentMixin],
  data() {
    return {};
  },
  created() {
    console.log("created");
    var cacheData = sessionStorage.getItem("fulfillmentConfirmCache");
    if (!cacheData) { this.getMedicineform(); }
  },
  mounted() {
    var mode = this.$route.query.mode;
    var cacheData = sessionStorage.getItem("fulfillmentConfirmCache");
    if (cacheData) {
      var cache = JSON.parse(cacheData);
      this.drugFormData = cache.drugFormData;
      this.deliveryFormData = cache.deliveryFormData;
      this.addressInfo = cache.addressInfo;
      this.addressTemp = cache.addressTemp;
      this.currentForm = cache.currentForm;
      this.addressInfoVisible = cache.addressInfoVisible;
      this.options = cache.options || [];
      this.forms = cache.forms || [];
      this.allocationQuantity = cache.allocationQuantity || [];
      this.medicineFormSpecificationsQuantity = cache.medicineFormSpecificationsQuantity || [];
      this.specificationType = cache.specificationType || "";
      this.adjustmentQuantityType = cache.adjustmentQuantityType || "";
      this.frequencyString = cache.frequencyString || "";
      this.dosageString = cache.dosageString || "";
      this.medicineFormSpecificationsDosage = cache.medicineFormSpecificationsDosage || [];
      this.medicineFormSpecificationsFrequency = cache.medicineFormSpecificationsFrequency || [];
      this.PromptOnAllocationQuantity = cache.PromptOnAllocationQuantity || "";
      this.isswitchList = cache.isswitchList || "其他";
      this.PriceInfo = cache.PriceInfo || "";
      this.pane = cache.pane || {};
      this.consultInfo = cache.consultInfo || {};
      sessionStorage.removeItem("fulfillmentConfirmCache");
    } else {
      var data = this.$store.getters.getFulfillmentConfirmData;
      if (!this.utils.isEmptyObject(data)) {
        this.drugFormData = data.drugFormData;
        this.addressInfo = data.addressInfo;
        if (data.addressInfo && data.addressInfo.length == 3) {
          this.addressTemp = data.addressInfo[0] + "/" + data.addressInfo[1] + "/" + data.addressInfo[2];
        }
        if (!this.utils.isEmptyObject(data.currentForm)) { this.currentForm = data.currentForm; }
        this.deliveryFormData = data.deliveryFormData;
      }
    }
    this.prescription = JSON.parse(sessionStorage.getItem("prescription")) || {};
    if (mode != 1) {
      // 地址簿往返时（存在缓存），pane 与 consultInfo 已在缓存恢复分支中赋值，此处不应再覆盖
      var isSuperfine = this.prescription.type && this.prescription.type.indexOf("_superfine_prescription") !== -1;
      if (!cacheData) {
        this.consultInfo = JSON.parse(sessionStorage.getItem("consultInfo"));
      }
      this.basicTableArray = JSON.parse(sessionStorage.getItem("basicTable"));
      this.shangjiaoTableArray = JSON.parse(sessionStorage.getItem("shangjiaoTableArray"));
      this.zhongjiaoTableArray = JSON.parse(sessionStorage.getItem("zhongjiaoTableArray"));
      this.xiajiaoTableArray = JSON.parse(sessionStorage.getItem("xiajiaoTableArray"));
      this.tablePrescription = JSON.parse(sessionStorage.getItem("tablePrescription"));
      var that = this;
      if (this.shangjiaoTableArray) {
        this.shangjiaoTableArray.forEach(function (element) { if (element.value.length > 0) { that.hasShangJiao = true; } });
      }
      if (this.zhongjiaoTableArray) {
        this.zhongjiaoTableArray.forEach(function (element) { if (element.value.length > 0) { that.hasZhongJiao = true; } });
      }
      if (this.xiajiaoTableArray) {
        this.xiajiaoTableArray.forEach(function (element) { if (element.value.length > 0) { that.hasXiaJiao = true; } });
      }
      var index = this.$route.query.index;
      this.prescriptionNo = index;
      if (isSuperfine) {
        // 超微饮片：pane 与 consultInfo 由 ChaoweiPrescriptionPage 直接写入 sessionStorage
        if (!cacheData) {
          var superfinePane = sessionStorage.getItem("superfinePane");
          var paneData = superfinePane ? JSON.parse(superfinePane) : null;
          if (Array.isArray(paneData)) {
            // superfinePane 保存了该就诊记录下所有调理方案：
            // 优先按方案笺页透传的方案名匹配，其次按选中 index 取，最后兜底取第一个
            var routeName = this.$route.query.name;
            var matchedPane = null;
            if (routeName) {
              for (var p = 0; p < paneData.length; p++) {
                if (paneData[p] && paneData[p].title === routeName) {
                  matchedPane = paneData[p];
                  break;
                }
              }
            }
            this.pane = matchedPane || paneData[index] || paneData[0] || {};
          } else {
            this.pane = paneData || {};
          }
          var superfinePatient = sessionStorage.getItem("superfinePatient");
          this.consultInfo = superfinePatient ? JSON.parse(superfinePatient) : {};
          // sessionStorage.removeItem("superfinePane");
          // sessionStorage.removeItem("superfinePatient");
        }
      } else {
        if (!cacheData) {
          this.pane = (this.tablePrescription && this.tablePrescription[index]) || {};
        }
      }
    }
    if (!cacheData) {
      this.wjtHttp.get(
        this, "/api/medicine/v2/forms/" + this.prescription.type, {}, false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.forms = data.data;
            if (mode == 1) { this.getDraft(); }
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "获取中草药形态异常", type: "error" });
          }
        },
        (err) => { console.log(err); }
      );
    }
    // 收件人回填：必须在缓存恢复之后执行，否则会被缓存的旧表单值覆盖
    var address = sessionStorage.getItem("selectAddress");
    if (address != null && address.length > 0) {
      var addressObj = JSON.parse(address);
      this.deliveryFormData.receiverName = addressObj.receiverName;
      this.deliveryFormData.phoneNo = addressObj.phoneNo;
      this.deliveryFormData.province = addressObj.province;
      this.deliveryFormData.city = addressObj.city;
      this.deliveryFormData.county = addressObj.county;
      this.addressInfo = addressObj.addressInfo;
      this.deliveryFormData.street = addressObj.street;
      this.deliveryFormData.zipCode = addressObj.zipCode;
      this.addressTemp = addressObj.addressInfo[0] + "/" + addressObj.addressInfo[1] + "/" + addressObj.addressInfo[2];
      this.addressInfoVisible = true;
    }
    sessionStorage.removeItem("selectAddress");
  },
  computed: {
    // 是否为超微饮片处方（控制配送服务/配送摘要/确认弹窗的字段文案）
    isSuperfine() {
      return this.prescription && this.prescription.type && this.prescription.type.indexOf("_superfine_prescription") !== -1;
    },
  },
  methods: {
    // ===== 动态表单核心方法（保留原逻辑）=====
    radioChange() {
      this.currentForm = this.forms.find((item) => item.formName == this.drugFormData.currentFormName);
      this.isswitchList = "其他";
      this.deliveryFormData.deliveryId = "";
      this.drugFormData.quantityDispensed = "";
      this.drugFormData.specifications = "";
      this.drugFormData.drugCount = "";
      this.drugFormData.dosage = "";
      this.drugFormData.frequency = "";
      this.addSelect();
    },
    getConfigAndDeliveryId() {
      this.wjtHttp.get(
        this, "api/medicine/v2/getConfigAndDeliveryId",
        { formCode: this.currentForm.formCode, deliveryId: this.deliveryFormData.deliveryId },
        null,
        (res) => {
          this.drugFormData.quantityDispensed = "";
          this.drugFormData.specifications = "";
          this.drugFormData.drugCount = "";
          this.drugFormData.dosage = "";
          this.drugFormData.frequency = "";
          if (res.data.data.medicineFormSpecifications) { this.allocationQuantity = res.data.data.medicineFormSpecifications; }
          else { this.allocationQuantity = []; }
          if (res.data.data.medicineFormSpecificationsQuantity) { this.medicineFormSpecificationsQuantity = res.data.data.medicineFormSpecificationsQuantity; }
          else { this.medicineFormSpecificationsQuantity = []; }
          this.PromptOnAllocationQuantity = res.data.data.productionRequireString;
          this.specificationType = res.data.data.specificationType;
          this.adjustmentQuantityType = res.data.data.adjustmentQuantityType;
          this.medicineFormSpecificationsDosage = res.data.data.medicineFormSpecificationsDosage || [];
          this.medicineFormSpecificationsFrequency = res.data.data.medicineFormSpecificationsFrequency || [];
          this.dosageString = res.data.data.dosageString;
          this.frequencyString = res.data.data.frequencyString;
        }
      );
    },
    addSelect() {
      this.wjtHttp.get(
        this, "api/delivery/getCurrentDeliveryDept",
        { formCode: this.drugFormData.currentFormName },
        null,
        (res) => {
          var data = res.data;
          this.options = data.data;
          console.log(this.options, "99999999999");
          this.PriceInfoDel();
        }
      );
    },
    // ===== 提交与校验（保留原逻辑）=====
    submit() {
      // 演示账号限制：药食同源（超微方）允许配送放行，其他类型仍拦截
      if (this.isAgentDemo && !this.isSuperfine) {
        this.$message.warning("当前为演示账号，配送下单功能暂未开放");
        return;
      }
      if (this.drugFormData.currentFormName.length == 0) {
        this.$message(this.isSuperfine ? "请选择一个产品形态" : "请选择一个中草药形态");
        return;
      }
      if (!this.deliveryFormData.deliveryId) {
        this.$message("请选择配送中心");
        return;
      }
      if (this.drugFormData.drugCount <= 0) {
        this.$nextTick(() => { this.$refs.drugCountId.focus(); });
        this.$message(this.isSuperfine ? "请输入几剂，只能是大于0的数字" : "请输入几副药，只能是大于0的数字");
        return;
      }
      if (this.drugFormData.quantityDispensed.length == 0 && this.adjustmentQuantityType) {
        this.$message("请选择每副调配数量");
        return;
      }
      if (this.drugFormData.frequency.length == 0 && this.frequencyString) {
        this.$message(`请选择输入${this.frequencyString}`);
        return;
      }
      if (this.drugFormData.dosage.length == 0 && this.dosageString) {
        this.$message(`请选择输入${this.dosageString}`);
        return;
      }
      if (this.deliveryFormData.receiverName.length == 0) {
        this.$nextTick(() => { this.$refs.nameId.focus(); });
        this.$message("请输入收件人姓名");
        return;
      }
      if (this.deliveryFormData.phoneNo.length != 11) {
        this.$nextTick(() => { this.$refs.phoneId.focus(); });
        this.$message("请输入正确的11位手机号");
        return;
      }
      if (this.addressInfo.length == 0) {
        this.$message("请选择省市区");
        return;
      }
      if (this.deliveryFormData.street.length == 0) {
        this.$nextTick(() => { this.$refs.customAddressId.focus(); });
        this.$message("请输入详细地址");
        return;
      }
      this.dialogVisible = true;
    },
    getMedicineform() {
      var test = JSON.parse(sessionStorage.getItem("prescription"));
      var mode = this.$route.query.mode;
      this.wjtHttp.get(
        this, "/api/medicine/v2/forms/" + test.type, {}, false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.forms = data.data;
            if (mode == 1) { this.getDraft(); }
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "获取中草药形态异常", type: "error" });
          }
        },
        (err) => { console.log(err); }
      );
    },
    confirmOrder() {
      this.dialogVisible = false;
      this.wjtHttp.post(
        this, "/api/delivery/order/place",
        {
          deliveryType: "E",
          endDate: this.prescription.endDate,
          startDate: this.prescription.startDate,
          type: this.prescription.type,
          form: this.currentForm.formCode,
          remark: this.drugFormData.remark,
          formCount: this.drugFormData.drugCount,
          dosage: this.drugFormData.dosage,
          frequency: this.drugFormData.frequency,
          quantityDispensed: this.drugFormData.quantityDispensed,
          zipCode: this.deliveryFormData.zipCode,
          recipientAddress: this.deliveryFormData.province + this.deliveryFormData.city + this.deliveryFormData.county + this.deliveryFormData.street,
          recipientName: this.deliveryFormData.receiverName,
          recipientPhone: this.deliveryFormData.phoneNo,
          visitRecordId: this.prescription.visitRecordId,
          prescriptionImageUrls: this.prescription.imageUrl,
          deliveryId: this.deliveryFormData.deliveryId,
          prescriptionNo: this.prescriptionNo,
          prescriptionWithShipment: this.drugFormData.prescriptionWithShipment,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.$router.replace({ path: "/fulfillmentOrder", query: { orderId: data.data.deliveryOrderId } });
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "生成统一配送订单异常", type: "error" });
          }
        },
        (err) => { console.log(err); }
      );
    },
    getDraft() {
      this.wjtHttp.post(
        this, "/api/delivery/order/draft/info",
        { endDate: this.prescription.endDate, startDate: this.prescription.startDate, type: this.prescription.type, visitRecordId: this.prescription.visitRecordId },
        true,
        (res) => {
          if (res.data.data) {
            this.draftInfo = res.data.data;
            this.consultInfo = res.data.data.patient;
            this.setDraftInfo();
            this.generateTableData();
          }
        },
        (err) => { }
      );
    },
    saveDraft() {
      if (this.drugFormData.currentFormName.length == 0) {
        this.$message(this.isSuperfine ? "请选择一个产品形态" : "请选择一个中草药形态");
        return;
      }
      if (this.drugFormData.drugCount.length == 0 || this.drugFormData.drugCount == 0) {
        this.$nextTick(() => { this.$refs.drugCountId.focus(); });
        this.$message(this.isSuperfine ? "请输入几剂，只能是大于0的数字" : "请输入几副药，只能是大于0的数字");
        return;
      }
      if (this.deliveryFormData.receiverName.length == 0) {
        this.$nextTick(() => { this.$refs.nameId.focus(); });
        this.$message("请输入收件人姓名");
        return;
      }
      if (this.deliveryFormData.phoneNo.length == 0) {
        this.$nextTick(() => { this.$refs.phoneId.focus(); });
        this.$message("请输入收件人联系方式");
        return;
      }
      if (this.addressInfo.length == 0) {
        this.$message("请选择省市区");
        return;
      }
      if (this.deliveryFormData.street.length == 0) {
        this.$nextTick(() => { this.$refs.customAddressId.focus(); });
        this.$message("请输入详细地址");
        return;
      }
      this.wjtHttp.post(
        this, "/api/delivery/order/draft/save",
        {
          deliveryType: "E",
          endDate: this.prescription.endDate,
          form: this.currentForm.formCode,
          formCount: this.drugFormData.drugCount,
          recipientName: this.deliveryFormData.receiverName,
          recipientPhone: this.deliveryFormData.phoneNo,
          recipientAddress: this.deliveryFormData.province + this.deliveryFormData.city + this.deliveryFormData.county + this.deliveryFormData.street,
          province: this.deliveryFormData.province,
          city: this.deliveryFormData.city,
          county: this.deliveryFormData.county,
          street: this.deliveryFormData.street,
          zipCode: this.deliveryFormData.zipCode,
          remark: this.drugFormData.remark,
          startDate: this.prescription.startDate,
          type: this.prescription.type,
          visitRecordId: this.prescription.visitRecordId,
        },
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "保存草稿成功" });
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "保存草稿异常", type: "error" });
          }
        },
        (err) => { console.log(err); }
      );
    },
    medicinePrice() {
      var ganzhiTypes = ["monthly_prescription", "daily_prescription", "hourly_prescription", "monthly_granules", "daily_granules", "hourly_granules"];
      var priceUrl = "/api/delivery/order/calDelivery/deliveryMedicinePrice";
      if (this.prescription.type && ganzhiTypes.indexOf(this.prescription.type.trim()) > -1) {
        priceUrl = "/api/delivery/order/calDelivery/disGanZhiMedicinePrice";
      }
      this.wjtHttp.post(
        this, priceUrl,
        {
          index: this.$route.query.index,
          deliveryType: "E",
          endDate: this.prescription.endDate,
          startDate: this.prescription.startDate,
          type: this.prescription.type,
          form: this.currentForm.formCode,
          remark: this.drugFormData.remark,
          formCount: this.drugFormData.drugCount,
          quantityDispensed: this.drugFormData.quantityDispensed,
          zipCode: this.deliveryFormData.zipCode,
          recipientAddress: this.deliveryFormData.province + this.deliveryFormData.city + this.deliveryFormData.county + this.deliveryFormData.street,
          recipientName: this.deliveryFormData.receiverName,
          recipientPhone: this.deliveryFormData.phoneNo,
          visitRecordId: this.prescription.visitRecordId,
          deliveryId: this.deliveryFormData.deliveryId,
          prescriptionWithShipment: this.drugFormData.prescriptionWithShipment,
          prescriptionNo: this.prescriptionNo,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) { this.PriceInfo = data.data; }
          else { this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "生成价格失败", type: "error" }); }
        },
        (err) => { console.log(err); }
      );
    },
  },
};
</script>

<style scoped>
.ful-sidebar dt {
  color: #000;
}

.ful-sidebar dd {
  color: #000;
  font-weight: 400;
}
</style>
